var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.674 9h8.652c.6 0 .9-.639.476-1.012l-4.326-3.814a.738.738 0 00-.952 0L5.198 7.988C4.775 8.36 5.075 9 5.674 9zm-.37 2.072a.59.59 0 01.359-.067h8.674a.59.59 0 01.607.332.584.584 0 01-.132.678l-4.335 3.812a.742.742 0 01-.954 0l-4.335-3.812a.585.585 0 01.117-.943z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default ForwardRef;